import {
  Directive,
  ElementRef,
  HostListener,
  Optional,
  Self
} from '@angular/core';
import { NgModel } from '@angular/forms';

@Directive({
  selector: '[short-date]'
})
export class ShortDateInputDirective {
  constructor (
    private el     : ElementRef<HTMLInputElement>,
    @Optional() @Self()
    private ngModel: NgModel
  ) {}

  @HostListener('input', [ '$event.target.value' ])
  onInput ( value : string ) : void {
    const stripped = value.replace(/[^\d/]/g, '');

    if ( stripped !== value ) {
      this.el.nativeElement.value = stripped;

      if ( this.ngModel ) {
        this.ngModel.viewToModelUpdate(stripped);
      }
    }
  }

  @HostListener('blur')
  onBlur () : void {
    const value = this.el.nativeElement.value;

    if ( !value ) return;

    const formatted = this.formatShortDate(value);

    if ( formatted && formatted !== value ) {
      this.el.nativeElement.value = formatted;

      if ( this.ngModel ) {
        this.ngModel.viewToModelUpdate(formatted);
      }
    }
  }

  private formatShortDate ( value : string ) : string | null {
    const stripped = value.replace(/\D/g, '');

    if ( stripped.length === 6 ) {
      const month = parseInt(stripped.substring(0, 2), 10);
      const year  = parseInt(stripped.substring(2, 6), 10);

      if ( month >= 1 && month <= 12 && year >= 1900 && year <= 2100 ) {
        return `${ this.pad(month) }/${ year }`;
      }
    }

    if ( value.includes('/') ) {
      const parts = value.split('/');

      if ( parts.length === 2 ) {
        const month = parseInt(parts[0], 10);
        const year  = parseInt(parts[1], 10);

        if ( month >= 1 && month <= 12 && year >= 1900 && year <= 2100 ) {
          return `${ this.pad(month) }/${ year }`;
        }
      }
    }

    return null;
  }

  private pad ( n : number ) : string {
    return n < 10 ? `0${ n }` : `${ n }`;
  }
}
